import React from 'react';

import PlanFilterContainer from '../components/PlanFilterContainer';

const Policy = () => <PlanFilterContainer pageLabel="Medical Policy" />;

export default Policy;
